<template>
    <v-container>
        <v-skeleton-loader
            v-if="!tryouts"
            type="list-item-avatar-two-line@3"
        ></v-skeleton-loader>
        <template v-else>
            <late-release-tryout :tryouts="tryouts"></late-release-tryout>

            <v-list class="elevation-1">
                <v-list-item
                    v-for="tryout in tryouts"
                    :key="tryout.hash"
                    @click="showTryout(tryout)"
                    two-line
                    link
                >
                    <v-list-item-avatar
                        :color="tryout.is_released ? 'primary' : 'grey'"
                    >
                        <v-icon
                            v-if="!tryout.is_released"
                            color="white"
                        >
                            mdi-calendar
                        </v-icon>

                        <v-icon
                            v-else-if="tryout.state === 'finished'"
                            color="white"
                        >
                            mdi-check-bold
                        </v-icon>

                        <v-icon
                            v-else-if="tryout.state === 'paused'"
                            color="white"
                        >
                            mdi-pause
                        </v-icon>

                        <v-icon
                            v-else
                            color="white"
                        >
                            mdi-file-question-outline
                        </v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>
                            {{ tryout.title }}
                        </v-list-item-title>

                        <v-list-item-subtitle v-if="tryout.is_released">
                            {{ tryout.question_count }} Soal,
                            {{ tryout.minute_limit }} Menit
                        </v-list-item-subtitle>

                        <v-list-item-subtitle v-else>
                            {{ tryout.released_at }}
                        </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action v-if="tryout.is_released">
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </template>
    </v-container>
</template>

<script>
import moment, { parseFromServer } from '@/plugins/moment'
import LateReleaseTryout from './components/LateReleaseTryout.vue'

export default {
    components: {
        LateReleaseTryout,
    },

    data() {
        return {
            tryouts: null,
        }
    },

    methods: {
        showTryout(tryout) {
            if (
                tryout.is_released ||
                this.$store.get('auth/username') == 'icebear3' ||
                this.$store.get('auth/username') ==
                    'Bernadethakusuma@gmail.com' ||
                this.$store.get('auth/email') == 'iganadyaputri@gmail.com' ||
                this.$store.get('auth/email') == 'enamedindonesia@gmail.com'
            ) {
                this.$router.push({
                    name: 'tryout.prestart',
                    params: { hash: tryout.hash },
                })
            }
        },
    },

    created() {
        this.$api.get('tryout').then((response) => {
            this.tryouts = response.data.tryouts.map((e) => {
                return {
                    ...e,
                    released_at: parseFromServer(
                        e.released_at
                    ).formatShortDayAndTime(),
                    is_released: moment().isAfter(
                        parseFromServer(e.released_at)
                    ),
                }
            })
        })
    },
}
</script>
